module.exports = {
  title: 'Page title',
  description:
    'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium',
  meta: 'Meta info',
};
